import { useState } from 'react';

interface Props {
  /** Commande ou contenu à exécuter, tel quel. */
  contenu: string;
  /** Où l'exécuter — l'information la plus souvent absente d'une documentation. */
  où?: string;
}

/**
 * Bloc de commande copiable.
 *
 * Une clé publique ou une commande d'installation se recopient à la main sinon, et une clé SSH
 * recopiée à la main se recopie mal : un caractère manquant produit une erreur d'authentification
 * qu'on met un quart d'heure à attribuer à une faute de frappe.
 *
 * `où` est affiché avec la commande parce que c'est l'information qui manque le plus souvent :
 * savoir quoi taper ne sert à rien si l'on ignore sur quelle machine.
 */
export function BlocCommande({ contenu, où }: Props) {
  const [copié, setCopié] = useState(false);

  async function copier() {
    try {
      await navigator.clipboard.writeText(contenu);
      setCopié(true);
      setTimeout(() => setCopié(false), 2000);
    } catch {
      // Le presse-papiers peut être refusé par le navigateur : le contenu reste sélectionnable.
      setCopié(false);
    }
  }

  return (
    <div className="bloc-commande">
      <div className="bloc-commande-entete">
        {où !== undefined && <span className="etiquette">{où}</span>}
        <button type="button" className="lien" onClick={() => void copier()}>
          {copié ? 'copié' : 'copier'}
        </button>
      </div>
      <pre>{contenu}</pre>
    </div>
  );
}
